// extracted by mini-css-extract-plugin
export default {"primary":"Button_primary__XYgy-","secondary":"Button_secondary__QwN49"};